<div class="container-fluid">


  <!-- <div class="container">
    <img class="img-responsive" src="../../assets/emr-header.png">
  </div> -->


  <div class="container">
    <div class="border-line">
      <h1>Register for 90 days FREE trial</h1>
      <p>For Ayurvedic Doctors and Practitioners, a blend of next generation patient care mechanism, a two way
        communication for patients and doctors, an integrative oncology system, and world class products backed by
        research, an extensive distribution system in the USA and a fun and loving education based on our traditional
        sciences for kids through adventures of Vata, Pitta and Kapha.<br><br><br>
        To expand and modernise your practice, in any or all of the above areas, please fill this small form and we will
        create your account and share the credentials. You can use this FREE for 90 days.</p>
    </div>
    <div class="emailid">
      <!-- <p><i class="bi-eye-slash"></i> <b>mouna200985@gmail.com</b> (not shared) <a herf="#">Switch accounts</a> <i class="bi-cloud-check"></i></p> -->
      <p class="red">*Required</p>
    </div>
  </div>


  <form id="scrollForError" [formGroup]="emrForm">
    <div class="container">
      <div class="form-group">
        <label for="exampleInputName">Full Name <span class="red">*</span></label>
        <input type="text" class="form-control" id="exampleInputName2" placeholder="Your Answer"
          formControlName="fullName">
      </div>

      <div *ngIf="emrForm.get('fullName').hasError('required') && emrForm.get('fullName').touched">
        <small class="error">Full Name should not be empty</small>
      </div>
      <div *ngIf="emrForm.get('fullName').hasError('minlength')&& emrForm.get('fullName').touched">
        <small class="error">Full Name should contain minimum 3 characters</small>
      </div>
      <div *ngIf="emrForm.get('fullName').hasError('maxlength')&& emrForm.get('fullName').touched">
        <small class="error">Full Name should contain maximum 35 characters</small>
      </div>
      <div *ngIf="emrForm.get('fullName').hasError('pattern')&& emrForm.get('fullName').touched">
        <small class="error">Please enter only Alphabets</small>
      </div>
    </div>
    <div class="container">
      <div class="form-group">
        <label for="exampleInputEmail">Email <span class="red">*</span></label>
        <input type="email" class="form-control" id="exampleInputEmail2" placeholder="Your Answer"
          formControlName="email">
      </div>
      <div *ngIf="emrForm.get('email').hasError('required')&& emrForm.get('email').touched">
        <small class="error">Please enter your Email</small>
      </div>
      <div *ngIf="emrForm.get('email').hasError('email')&& emrForm.get('email').touched">
        <small class="error">Please enter a valid Email</small>
      </div>
      <div class="error" *ngIf="formErrors?.bool">{{formErrors.data.email}}</div>
    </div>

    <!-- country state city -->
    <div class="container">
      <div class="form-group">
        <label for="exampleInputName">Country</label>
        <select id="country" class="form-control" formControlName="country" (change)="getState(emrForm.get('country').value)">
          <option value="" disabled>Select Country</option>
          <option *ngFor="let country of countries" [ngValue]="country">{{country.countryName}}</option>
          
          <!-- <option value="{countryId:-1}">Other</option> -->
        </select>

        <input *ngIf="emrForm.get('country').value?.countryId === -1" type="text" class="form-control half"
          [(ngModel)]="countryOthers" id="exampleInputName2" placeholder="Add your country"
          [ngModelOptions]="{standalone: true}">
      </div>
    </div>
    <div class="container">
      <div class="form-group">
        <label for="exampleInputName">State</label>
        <select id="state" class="form-control" formControlName="state" (change)="getCity(emrForm.get('state').value)">
          <option value="" disabled>Select State</option>
          <option *ngFor="let state of states" [ngValue]="state">{{state.stateName}}</option> 
          <option *ngIf="emrForm.get('country').value?.countryId === -1" value="{stateId:-1}">Other</option>
        </select>
        <input *ngIf="emrForm.get('state').value?.stateId == -1" type="text" class="form-control half" [(ngModel)]="stateOthers"
          id="exampleInputName2" placeholder="Add your state" [ngModelOptions]="{standalone: true}">
      </div>
    </div>
    <div class="container">
      <div class="form-group">
        <label for="exampleInputName">City</label>
        <select id="city" class="form-control" formControlName="city">

          <option value="" disabled>Select City</option>
          <!--<option value="null" *ngIf="showDisabled">Select Country</option>-->
          <option *ngFor="let city of cities" [ngValue]="city">{{city.cityName}}</option>

          <option *ngIf="(emrForm.get('country').value?.countryId === -1 ||emrForm.get('state').value?.stateId === -1)" value="{cityId:-1}">Other</option>

        </select>
        <input *ngIf="emrForm.get('city').value?.cityId === -1" type="text" class="form-control half" id="exampleInputName2"
          placeholder="Add your city" [(ngModel)]="cityOthers" [ngModelOptions]="{standalone: true}">
      </div>
    </div>




    <div class="container">
      <div class="form-group">
        <label for="phone">Mobile number <span class="red">*</span></label>
        <input type="tel" class="form-control" id="phone" name="phone" placeholder="Your Answer"
          formControlName="mobile">
      </div>
      <div *ngIf="emrForm.get('mobile').hasError('required')&& emrForm.get('mobile').touched">
        <small class="error">Please enter your phone number</small>
      </div>
      <div *ngIf="emrForm.get('mobile').hasError('pattern')&& emrForm.get('mobile').touched;else test">
        <small class="error">Please enter in digits</small>
      </div>
      <ng-template #test>
        <div *ngIf="emrForm.get('mobile').hasError('minlength')&& emrForm.get('mobile').touched">
          <small class="error">Please enter minimum 10 digits</small>
        </div>
        <div *ngIf="emrForm.get('mobile').hasError('maxlength')&& emrForm.get('mobile').touched">
          <small class="error">Please enter maximum 10 digits</small>
        </div>
      </ng-template>
    </div>
    <div class="container">
      <div class="form-group">
        <label for="exampleInputName">Name of the city where you practice </label>
        <input type="text" class="form-control" id="exampleInputName2" placeholder="Your Answer"
          formControlName="practiceCityName">
      </div>
    </div>
    <div class="container">
      <div class="spacing">
        <label for="exampleInputName">Do you have Panchkarma facility in your clinic? <span class="red">*</span></label>
        <div class="radio">
          <label>
            <input type="radio" name="panchKarmaFacility" id="optionsRadios1" value="true"
              formControlName="panchKarmaFacility">
            Yes
          </label>
        </div>
        <div class="radio">
          <label>
            <input type="radio" name="panchKarmaFacility" id="optionsRadios2" value="false"
              formControlName="panchKarmaFacility">
            No
          </label>
        </div>
      </div>
      <div *ngIf="emrForm.get('panchKarmaFacility').hasError('required')&& emrForm.get('panchKarmaFacility').touched">
        <small class="error">Please check the Panchakarma facility availability</small>
      </div>
    </div>
    <div class="container">
      <div class="form-group">
        <label for="exampleInputName">Which Ayurveda EMR are you using presently? </label>
        <input type="text" class="form-control" id="exampleInputName2" placeholder="Your Answer"
          formControlName="ayurvedaEMR">
      </div>
    </div>

    <button type="submit" class="btn btn-default bb2" (click)="resetForm()">Clear Form</button>
    <button type="submit" class="btn btn-default bb" (click)="submitEmr()">Submit</button>
  </form>

</div>








<ng-template #msg>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Message</h4>
    <button type="button" class="closeModal" data-dismiss="modal" (click)="modalClose()"><i
        class="bi bi-x-circle"></i></button>
  </div>
  <!-- Modal body -->
  <div class="modal-body">
    <p class="text-center">{{modalService.config.initialState.message}}</p>
  </div>
  <!-- Modal footer -->
  <div class="modal-footer">
    <!-- <button type="button" class="btn btn-danger" (click)="modalClose()">CANCEL</button> -->
    <button type="button" class="btn-blue" (click)="modalClose()">OK</button>
  </div>
</ng-template>